var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseReader',{attrs:{"content":_vm.content},on:{"click-link":(e, a) => _vm.$emit('click-link', e, a)}})
}
var staticRenderFns = []

export { render, staticRenderFns }